import PropTypes from 'prop-types';
import { useEffect, useState, useCallback } from 'react';

import { IconDropdownArrow } from '../icons/icon-dropdown-arrow/icon-dropdown-arrow';
import { Popover, PopoverContent, PopoverTrigger } from '../popover/popover';

import { BreadCrumbsMenu } from './bread-crumbs-menu/bread-crumbs-menu';
import { BreadCrumbKeyType } from './bread-crumbs-prop-types';

import './bread-crumbs-dropdown.scss';

function useBreadCrumbsDropdownData(loadData, type, isOpen) {
  const [items, setItems] = useState([]);
  const shouldFetchData = isOpen && items.length === 0;

  useEffect(() => {
    // new loadData method arrives here when user goes to another match, so crumbs from previous should be cleared
    setItems([]);
  }, [loadData]);

  useEffect(() => {
    if (shouldFetchData) {
      loadData(type).then(fetchedItems => {
        setItems(fetchedItems);
      });
    }
  }, [shouldFetchData]);

  return items;
}

export function BreadCrumbsDropdown({ activeKey, type, isLive, loadData }) {
  const [isOpen, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(open => !open), []);
  const items = useBreadCrumbsDropdownData(loadData, type, isOpen);

  return (
    <Popover open={isOpen} onOpenChange={toggle}>
      <PopoverTrigger className="sb-BreadCrumbsDropdown-toggle">
        <IconDropdownArrow isOpen={isOpen} />
      </PopoverTrigger>
      <PopoverContent align="start" className="sb-BreadCrumbsDropdown-menu" side="bottom">
        <BreadCrumbsMenu
          activeKey={activeKey}
          isLive={isLive}
          isOpen={isOpen}
          items={items}
          type={type}
          onClick={toggle}
        />
      </PopoverContent>
    </Popover>
  );
}

BreadCrumbsDropdown.propTypes = {
  type: PropTypes.string.isRequired,
  activeKey: BreadCrumbKeyType.isRequired,
  loadData: PropTypes.func.isRequired,
  isLive: PropTypes.bool,
};

BreadCrumbsDropdown.defaultProps = {
  isLive: false,
};
